import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../utils/api";

export const createJob = createAsyncThunk(
  "jobs/createJob",
  async ({
    soWo,
    prodOrderNo,
    woDate,
    jobName,
    poNo,
    estimatedtotalCT,
    actualtotalCT,
    dragNo,
    processTable,
  }) => {
    try {
      const response = await api.post(`/createjob`, {
        soWo,
        prodOrderNo,
        woDate,
        jobName,
        poNo,
        estimatedtotalCT,
        actualtotalCT,
        dragNo,
        processTable,
      });
      console.log("res", response?.data);

      return response?.data?.Job;
    } catch (err) {
      console.error("Error", err.response.data);
      return err.response.data;
    }
  }
);

export const getAllJob = createAsyncThunk("jobs/getAllJob", async () => {
  try {
    const response = await api.get(`/jobs`);

    const job = response.data.jobs;

    return job;
  } catch (err) {
    console.error("Error", err.response.data);
    return err.response.data;
  }
});

export const getSingleJob = createAsyncThunk(
  "jobs/getSingleJob",
  async (id) => {
    console.log("id", id);
    try {
      const response = await api.get(`/viewjob/${id}`);

      const job = response.data.job;

      return job;
    } catch (err) {
      console.error("Error", err.response.data);
      return err.response.data;
    }
  }
);

export const deleteJob = createAsyncThunk("jobs/deleteJob", async (id) => {
  try {
    const response = await api.delete(`/deletejob/${id}`);
    console.log("res", response.data);
    return id;
  } catch (err) {
    console.error("Error", err.response.data);
    return err.response.data;
  }
});

export const editJob = createAsyncThunk(
  "jobs/editJob",
  async (editFormData) => {
    try {
      const response = await api.put(
        `/updatejob/${editFormData.id}`,
        editFormData.formData
      );
      console.log("res", response?.data);

      return response?.data;
    } catch (err) {
      console.error("Error", err.response.data);
      return err.response.data;
    }
  }
);

export const generatePDF = createAsyncThunk("jobs/generatePDF", async (id) => {
  try {
    const response = await api.get(`/generatePdf/${id}`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    // saveAs(blob, "job.pdf");
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "job.pdf";
    a.click();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error(
      "Error generating PDF:",
      error.response ? error.response.data : error.message
    );
    return {
      success: false,
      error: error.response ? error.response.data : error.message,
    };
  }
});

export const copyOfJob = createAsyncThunk(
  "jobs/copyJob",
  async ({ id, count }) => {
    console.log("pppid", id, count);
    try {
      const response = await api.post(`/copyJob/${id}`, { count }); // Pass count in the request body

      const job = response.data.Jobs;
      console.log("ppp", response.data.Jobs);
      return job; // Return the duplicated jobs
    } catch (error) {
      console.error(
        "Error generating:",
        error.response ? error.response.data : error.message
      );
      return {
        success: false,
        error: error.response ? error.response.data : error.message,
      };
    }
  }
);

export const creatTool = createAsyncThunk("tools/createTools", async (raw) => {
  try {
    const response = await api.post(`/createTools`, raw);
    console.log("restool create", response?.data);

    return response?.data?.tools;
  } catch (err) {
    console.error("Error", err.response.data);
    return err.response.data;
  }
});

export const getAllTools = createAsyncThunk("tools/getAllTools", async () => {
  try {
    const response = await api.get(`/getTools`);
    console.log("response tool getting", response.data);

    return response.data.tools;
  } catch (err) {
    console.error("Error", err.response.data);
    return err.response.data;
  }
});
